import React from 'react';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';
import { videoUrlHelper } from './videoUrlHelper';
import { Icon, Embed, Message } from 'semantic-ui-react';
import { ConditionalEmbed } from 'volto-gdpr-privacy';
import { isInternalURL, getParentUrl } from '@plone/volto/helpers';

import config from '@plone/volto/registry';

const VideoViewer = ({
  url,
  preview_image,
  title,
  align,
  isEditMode,
  allowsExternals,
}) => {
  const _allowsExternals =
    allowsExternals !== undefined
      ? !!allowsExternals
      : !!config.settings.videoAllowExternalsDefault;
  let placeholder = null;
  let videoID = null;
  let listID = null;

  if (url) {
    const [computedID, computedPlaceholder] = videoUrlHelper(
      url,
      preview_image,
    );
    if (computedID) {
      videoID = computedID;
    }
    if (computedPlaceholder) {
      placeholder = computedPlaceholder;
    }
  }
  const ref = React.createRef();
  const onKeyDown = (e) => {
    if (e.nativeEvent.keyCode === 13) {
      //Enter
      ref.current.handleClick();
    }
  };
  const embedSettings = {
    placeholder: placeholder,
    icon: (
      <div
        className="icon-play"
        role="button"
        tabIndex={0}
        title="Load and Play video"
      >
        <Icon name="play" />
      </div>
    ),
    defaultActive: false,
    autoplay: false,
    aspectRatio: '16:9',
    tabIndex: 0,
    onKeyPress: onKeyDown,
    ref: ref,
  };

  let apiPath = config.settings.apiPath;
  if (!apiPath.endsWith('/')) {
    apiPath += '/';
  }

  return (
    <>
      {url && (
        <div
          className={cx('video-inner', {
            'full-width': align === 'full',
          })}
        >
          <ConditionalEmbed url={url}>
            {url.match('youtu') ? (
              <>
                {url.match('list') ? (
                  <Embed
                    url={`https://www.youtube.com/embed/videoseries?list=${listID}`}
                    {...embedSettings}
                  />
                ) : (
                  <Embed id={videoID} source="youtube" {...embedSettings} />
                )}
              </>
            ) : (
              <>
                {url.match('vimeo') ? (
                  <Embed id={videoID} source="vimeo" {...embedSettings} />
                ) : (
                  <>
                    {url.match('.mp4') ? (
                      // eslint-disable-next-line jsx-a11y/media-has-caption
                      <video
                        src={
                          isInternalURL(url.replace(getParentUrl(apiPath), ''))
                            ? `${url}${
                                url.indexOf('@@download/file') < 0
                                  ? '/@@download/file'
                                  : ''
                              }`
                            : url
                        }
                        controls
                        poster={placeholder}
                        type="video/mp4"
                      />
                    ) : url && _allowsExternals ? (
                      // eslint-disable-next-line jsx-a11y/media-has-caption
                      <video
                        src={url}
                        controls
                        poster={placeholder}
                        type="video/mp4"
                      />
                    ) : isEditMode ? (
                      <div>
                        <Message>
                          <center>
                            <FormattedMessage
                              id="Please enter a valid URL by deleting the block and adding a new video block."
                              defaultMessage="Please enter a valid URL by deleting the block and adding a new video block."
                            />
                          </center>
                        </Message>
                      </div>
                    ) : (
                      <div className="invalidVideoFormat" />
                    )}
                  </>
                )}
              </>
            )}
          </ConditionalEmbed>
        </div>
      )}
    </>
  );
};

export default VideoViewer;
